import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

interface IDisclosuresListRenderButton {
    open: boolean;
    disclosureName: string | null;
    className?: string;
}

/** Selected Disclosure button that toggles the `DisclosuresList` or `PopupDisclosureList` dropdown menus */
const DisclosuresRenderButton = ({
    open,
    disclosureName,
    className,
}: IDisclosuresListRenderButton) => {
    const btnClasses = clsx(
        "inline-flex gap-[0.375rem] w-full justify-center items-center p-2 font-medium-light text-stone-darkest rounded-lg hover:bg-stone-lighter",
        open ? "bg-stone-lighter" : "bg-transparent",
        className
    );

    return (
        <div className={btnClasses}>
            {disclosureName}
            <ChevronDownIcon className="w-4 h-4" aria-hidden="true" />
        </div>
    );
};

export default DisclosuresRenderButton;
